import { render } from "./AboutMe.vue?vue&type=template&id=5167daea"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"
script.render = render

export default script